const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {
}

export const actions = {
  async checkSsoHealth({ commit }) {
    let result =  await this.$axios.$get('ssoauthentication/check-sso-health');
    return result && result.status == "ok";
  },
  async loginWithSso({ commit }) {
    let loginRequestData = {}
    try {
      let result = await this.$axios.get('ssoauthentication/login-with-sso');
      loginRequestData = result.data;
    }
    catch (error) {
      console.error("Error while getting login request data", error);
      this.$toast.error("Error occured while trying to log in through SSO.")
    }
    return loginRequestData;
  },
  async handleSSOCallback({ commit }, request) {
    let loginResult = null;
    try {
      return await this.$axios.post('ssoauthentication/callback', request);
    }
    catch (error) {
      console.error("Error while handling SSO callback.", error);
      this.$toast.error("Error occured while trying to log in through SSO.");
    }
    return loginResult;
  }
}
